export default {
  complex: {
    avg_price_sqm: 'Average price per m²',
    min_price: 'Minimum price',
    max_price: 'Maximum price',
    expected_delivery: 'Expected delivery',
    construction_start: 'Construction start',
    construction_end: 'Construction end',
    sales_start: 'Sales start',
    distance_to_sea: 'Distance to the sea',
    distance_to_center: 'Distance to the center',
    distance_to_airport: 'Distance to the airport',
    roi: 'ROI projection',
    amenities: 'Amenities',
    yes: 'Yes',
    no: 'No',
    infrastructure: 'Infrastructure',
    nearby: 'Nearby',
    gallery: 'Gallery',
    video: 'Video',

    // уже добавленные ключи
    total: 'Total units',
    available: 'Available',
    buildings: 'Buildings',
    floors_short: 'fl.',
    cover_alt: 'Residential complex cover',

    // 🔹 новые ключи для работы компонента
    details: {
      developer: 'Developer',
      location: 'Location',
      country: 'Country',
      region: 'Region',
      city: 'City',
      district: 'District',
      characteristics: 'Characteristics',
      class: 'Class',
      buildings_count: 'Number of buildings',
      construction_start: 'Construction start',
      sales_start: 'Sales start',
      construction_end: 'Construction end',
      delivery: 'Delivery',
      investments_prices: 'Investment & prices',
      total_value_available: 'Total value of available apartments',
      price_from: 'Price from',
      price_to: 'Price to',
      price_per_sqm: 'Price per m²',
      roi: 'ROI projection',
      amenities: 'Amenities',
      infrastructure: 'Infrastructure',
      description: 'Description',
      distances: 'Distances',
      to_sea: 'Distance to the sea',
      to_center: 'Distance to the center',
      to_airport: 'Distance to the airport'
    },

    // Примерные ключи для удобств
    amenities: {
      pool: 'Swimming pool',
      parking: 'Parking',
      gym: 'Gym',
      security: 'Security'
      // добавь сюда все, что есть в бэке
    },

    // Примерные ключи для инфраструктуры
    infrastructure: {
      school: 'School',
      kindergarten: 'Kindergarten',
      supermarket: 'Supermarket',
      hospital: 'Hospital'
      // добавь сюда все, что есть в бэке
    },

    properties_in_complex: 'Apartments in this complex',
    description: 'Description'
  },
  residential_class: {
    complex: {
      class: 'Class'
    }
  },
  loading: 'Loading...'
}
